import { createStyles } from "@mantine/core";

export default createStyles ( ( theme, props ) => {
	return {
		input: {
			"&:checked + .mantine-Switch-track": {

			},
			"&:checked + *>.mantine-Switch-thumb": {
				left   : "calc(100% - 1.75rem - 0.4rem)",
				border : "none"
			},
			"+ *>.mantine-Switch-thumb": {
				left: "0.4rem"
			}
		},
		track: {
			background : props?.checked ? theme.other.colors.antSwitch.checked.background : theme.other.colors.antSwitch.unchecked.background,
			transition : "background 0.1s ease",
			border     : "none",
			height     : "2.45rem"

		},
		switchTrack: {
		},
		thumb: {
			background : "white",
			border     : "none"
		}

	};
} );
